module.exports = {
          srcSet: __webpack_public_path__ + "517c2b1fc45d206a937a0dc610827023-62.png"+" 62w",
          images:[ {path: __webpack_public_path__ + "517c2b1fc45d206a937a0dc610827023-62.png",width: 62,height: 42}],
          src: __webpack_public_path__ + "517c2b1fc45d206a937a0dc610827023-62.png",
          toString:function(){return __webpack_public_path__ + "517c2b1fc45d206a937a0dc610827023-62.png"},
          
          width: 62,
          height: 42
        }